import { settingsActionsTypes } from "../constants/ActionTypes";
import {apiGet, apiPost} from "../utils/Api";

const setAvailableLocalesAction = (data) => {
  return {
    type: settingsActionsTypes.SET_AVAILABLE_LOCALES,
    locales: data.locales,
    defaultLocale: data.defaultLocale
  };
};

const setLocaleAction = (locale) => {
  return {
    type: settingsActionsTypes.SET_LOCALE,
    locale: locale
  };
};

const getLocales = () => {
  return (dispatch, getState) => {
    apiGet("/settings/i18n")
      .then((json) => {
        dispatch(setAvailableLocalesAction(json.data));
      });
  };
};

const setLocale = (locale) => {
  return (dispatch) => {
    apiPost(`/settings/i18n/${locale}`)
      .then(json => {
        if (json.status === 'success') {
          localStorage.setItem("userLocale", locale);
          window.location.reload();
        }
      });
  };
};

const getSettings = () => {
  return (dispatch) => {
    // apiGet("/settings")
    //       .then((json) => {
    //        // console.log('json', json);
    //         // dispatch(setAvailableLocalesAction(json.data));
    //       });
  };
};

export default {
  getLocales,
  setLocale,
  getSettings
};



// WEBPACK FOOTER //
// ./actions/settings.actions.js